import { createContext } from 'react';
import { ChatFilter } from '../../types/chats';

export const FILTERS_STORAGE_KEY = 'porter_chat_filters';

export const DEFAULT_FILTER_STATE = {
  filter: ChatFilter.ALL,
};

export type ChatFilterState = typeof DEFAULT_FILTER_STATE;

export const getInitialState = () => {
  try {
    const filters = sessionStorage.getItem(FILTERS_STORAGE_KEY);
    if (!filters) {
      return DEFAULT_FILTER_STATE;
    }

    const { filter } = JSON.parse(filters || '{}');

    const isValidFilter = Object.values(ChatFilter).includes(filter);

    return {
      filter: isValidFilter ? (filter as ChatFilter) : ChatFilter.ALL,
    };
  } catch {
    return DEFAULT_FILTER_STATE;
  }
};

export type ChatFilterStateAction =
  | { type: 'SET_FILTER'; payload: ChatFilter }
  | { type: 'RESET' };

interface AppContextType {
  state: ChatFilterState;
  dispatch: React.Dispatch<ChatFilterStateAction>; // Replace 'any' with the actual action type if you have one
}

const defaultContextValue: AppContextType = {
  state: getInitialState(),
  dispatch: () => {},
};

export const ChatContext = createContext<AppContextType>(defaultContextValue);
